import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { GenericCheckBoxStatus } from "../../../common/generic-check-box-with-minus/generic-checkbox-with-minus.component";
import { AppUserModel } from "../user-management-models/app-user.model";

@Component({
  selector: "user-management-row-header",
  templateUrl: "./user-management-row-header.component.html",
  styleUrls: [
    "../user-management-row/user-management-row.component.scss",
    "./user-management-row-header.component.scss",
  ],
})
export class UserManagementRowHeaderComponent {
  public readonly IS_SELECT_ALL_ACTIVE = false;
  public appUserHeader: Record<keyof Partial<AppUserModel>, string> = {
    id: "מזהה",
    firstName: "שם פרטי",
    lastName: "שם משפחה",
    userName: "שם משתמש",
    email: "אימייל",
    mobileNumber: "טלפון",
    activityCircles: "שדה פעילות",
    isActive: "פעיל",
    lastLogin: "כניסה אחרונה",
    canEditPermissionLevel: "ניתן לעריכה",
  };
  @Input("indentToScrollBar") public indentToScrollBar: boolean = false;
  @Output("changeCheckboxStatus")
  public changeCheckboxStatus: EventEmitter<GenericCheckBoxStatus> = new EventEmitter<GenericCheckBoxStatus>();

  public _selectionStatus: GenericCheckBoxStatus;

  @Input("selectionStatus") public set selectionStatus(
    value: GenericCheckBoxStatus
  ) {
    this._selectionStatus = value;
  }

  public changeCheckboxStatusHandler($event: GenericCheckBoxStatus) {
    this.changeCheckboxStatus.emit($event);
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/users/user-management-row-header/user-management-row-header.component.ts